import { Col, Form, Row, Select, Input } from "antd";
import { useEffect, useState } from "react";
import {
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  SALES_CONTRACT_LIST,
  STYLE_MERCHANDISING_LIST,
  ALL_SALES_CONTRACT_LIST
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
const SalesContractCommercialFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salseCotractList, setSalseCotractList] = useState([]);

  useEffect(() => {
    getSalseCotractList();
  }, []);

  const getSalseCotractList = async () => {
    let res = await getData(ALL_SALES_CONTRACT_LIST);

    if (res) {
      setSalseCotractList(res?.data?.data || []);
    }
  };
  return (
    <>
      <Col span={4}>
        <Form.Item label="Sales Contract No" name="sales_contract_id">
          <Select
            showSearch
            placeholder="Select a Sales Contract No"
            optionFilterProp="children"
            filterOption={(input, option) => 
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            size="small"
          >
            {salseCotractList?.length &&
              salseCotractList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.reference_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Tag Number" name="tag_number">
          <Input placeholder="Write Tag Number" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_name">
          <Input placeholder="Write Buyer Name" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Sales Contract Value" name="sales_contract_value">
          <Input placeholder="Write Sales Contract Value" size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default SalesContractCommercialFilterFields;
